import { Reveal } from "./Reveal";
import { LoopCarousel } from "./LoopCarousel";
import { CtaButton } from "./CtaButton";
import { LEARN_CARDS, APOSTILAS } from "../../data/content";

const Label = ({ children, testId }) => (
  <h2 data-testid={testId} className="font-display text-center text-3xl text-[var(--cream)] md:text-5xl">
    {children}
  </h2>
);

export const Journey = () => (
  <section data-testid="journey-section" className="relative overflow-hidden bg-[var(--forest)] py-24 md:py-32">
    <img src="/assets/frame_4.webp" alt="" className="absolute inset-0 h-full w-full object-cover opacity-80" />
    <div className="absolute inset-0 bg-gradient-to-b from-[var(--forest)] via-transparent to-[var(--forest)]" />
    <div className="relative">
      <Reveal className="mx-auto max-w-3xl px-5 text-center">
        <p className="text-[11px] font-semibold uppercase tracking-[0.42em] text-[var(--gold)]">
          Sua jornada de conhecimento começa aqui
        </p>
        <div className="mx-auto my-6 h-px w-16 bg-[#d9b45a]/50" />
        <Label testId="learn-title">O que você irá aprender?</Label>
        <p data-testid="learn-summary" className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-[var(--cream)]/80 md:text-lg">
          Além de receber <span className="text-[var(--gold)]">duas plataformas vitalícias</span> repletas de conhecimento — a Comunidade Umbanda para Todos e a EspiritualFlix — você terá aulas que percorrem toda a espiritualidade: Umbanda, mediunidade, energias, proteção e autoconhecimento. Um caminho guiado, com fundamento, para iluminar cada passo da sua jornada.
        </p>
      </Reveal>
      <Reveal delay={0.15} className="mt-12">
        <LoopCarousel
          images={LEARN_CARDS}
          testId="learn-carousel"
          alt="Conteúdo da comunidade Umbanda para Todos"
          itemClass="w-[44vw] sm:w-[220px] lg:w-[240px] aspect-[187/376] rounded-[18px] ring-1 ring-white/20"
        />
      </Reveal>

      <Reveal className="mt-24 px-5">
        <Label testId="receive-title">O que você irá receber?</Label>
        <p className="mx-auto mt-4 max-w-md text-center text-sm text-[var(--cream)]/75">
          Apostilas completas para acompanhar cada etapa do seu desenvolvimento.
        </p>
      </Reveal>
      <Reveal delay={0.15} className="mt-12">
        <LoopCarousel
          images={APOSTILAS}
          testId="apostilas-carousel"
          alt="Apostila Umbanda para Todos"
          itemClass="w-[44vw] sm:w-[200px] lg:w-[220px] aspect-[243/342] rounded-[6px] shadow-[0_30px_50px_-25px_rgba(0,0,0,0.9)]"
        />
      </Reveal>
      <Reveal className="mt-16 flex justify-center">
        <CtaButton testId="journey-cta-vitalicio" />
      </Reveal>
    </div>
  </section>
);
